import { render, staticRenderFns } from "./OverallSetting.vue?vue&type=template&id=c863ffc2&scoped=true"
import script from "./OverallSetting.vue?vue&type=script&lang=js"
export * from "./OverallSetting.vue?vue&type=script&lang=js"
import style0 from "./OverallSetting.vue?vue&type=style&index=0&id=c863ffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c863ffc2",
  null
  
)

export default component.exports